import React from 'react';
import { Icon, IconName } from 'app/common/components/controls';
import { forTemplate } from 'app/common/lib/util/i18n';
import styles from './ArchivedCardBanner.less';
import { CardBackTestIds } from '@trello/webdriverio-tests';

const format = forTemplate('card_detail');

export const ArchivedCardBanner: React.FunctionComponent = () => {
  return (
    <div
      className={styles.archivedBanner}
      data-test-id={CardBackTestIds.ArchivedBanner}
    >
      <Icon
        name={IconName.Archive}
        className={styles.archiveBannerIcon}
        large
      />
      <p className={styles.archivedBannerText}>
        {format('this-card-is-archived')}
      </p>
    </div>
  );
};
